<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>商品信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div>
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="商品名称">
                        <el-input v-model="listQuery.commodityName" placeholder="请输入商品名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品编码">
                        <el-input v-model="listQuery.spuCode" placeholder="请输入商品编码" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="品牌名称">
                        <el-input v-model="listQuery.brandName" placeholder="请输入品牌名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品类型">
                        <el-select v-model="listQuery.type" placeholder="请选择商品类型" clearable>
                            <el-option label="套餐" :value="1"></el-option>
                            <el-option label="单品" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售类型">
                        <el-select v-model="listQuery.salesType" placeholder="请选择销售类型" clearable>
                            <el-option label="租赁" value="1"></el-option>
                            <el-option label="售卖" value="2"></el-option>
                            <el-option label="租赁和售卖" value="3"></el-option>
                            <el-option label="补贴领用" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="listQuery.status" placeholder="请选择销售状态" clearable>
                            <el-option v-for="item in statusList" :key="item.id" :label="item.text" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商品类目">
                        <el-cascader v-model="listQuery.categoryId" :options="categoryList" :props="{ expandTrigger: 'hover',value:'id',label: 'categoryName',
          children: 'childCategorys'}" clearable :show-all-levels="false" size="mini"></el-cascader>
                    </el-form-item>
                    <el-form-item label="日期">
                        <el-date-picker v-model="listQuery.timePart" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="querySearch">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="el-icon-plus" plan @click="addCommodity">新增商品</el-button>
                    </el-form-item>
                </el-form>
                <!-- <el-row class="btn-margin">

        </el-row>-->
            </div>
            <el-table :data="tableData" border class="table">

                <el-table-column prop="id" label="ID" width="55" fixed="left" row-click="columnClick(row, column, cell, event)"></el-table-column>
                <el-table-column prop="commodityName" label="商品名称" width="100" fixed="left"></el-table-column>
                <el-table-column prop="type" label="商品类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">套餐</span>
                        <span v-if="scope.row.type == 2">单品</span>
                    </template>
                </el-table-column>
                <el-table-column prop="spuCode" label="商品编码"></el-table-column>
                <el-table-column prop="categoryName" label="商品类目"></el-table-column>
                <el-table-column prop="brandName" label="品牌"></el-table-column>

                <el-table-column prop="salesType" label="销售类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.salesType == 1">租借</span>
                        <span v-if="scope.row.salesType == 2">售卖</span>
                        <span v-if="scope.row.salesType == 3">租借和售卖</span>
                        <span v-if="scope.row.salesType == 4">补贴领用</span>

                    </template>
                </el-table-column>
                <el-table-column prop="satus" label="商品状态">
                    <template slot-scope="scope">{{scope.row.status | statusFilter}}</template>
                </el-table-column>

                <el-table-column prop="detail.detailDesc" label="商品详情描述"></el-table-column>
                <el-table-column prop="detail.picList" label="商品图片" width="200px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.detail.picList==''">无</span>
                        <el-image v-else slot="reference" :preview-src-list="picListFormat(scope.row.detail.picList)" v-for="item in scope.row.detail.picList" :key="item.index" :src="item.picAddress"></el-image>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="type" label="属性">
           <template slot-scope="scope">
            <span v-for="(item,index) in scope.row.bomList" :key="index" style="margin-right:10px;">{{item.propertyName}},</span>
          </template>
        </el-table-column>-->
                <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
                <el-table-column label="操作" fixed="right" width="200">
                    <template slot-scope="scope">
                        <!-- <el-button
                    type="text"
                    @click="handleEdit(scope.$index, scope.row)"
            >查看详情</el-button>-->
                        <el-button type="text" @click="ableCommodity(scope.row)" v-if="scope.row.status==2||scope.row.status==3||scope.row.status==5">上架</el-button>
                        <el-button type="text" class="red" @click="disableCommodity(scope.row)" v-if="scope.row.status==4">下架</el-button>
                        <el-button type="text" class="red" @click="deleteCommodity(scope.row)" v-if="scope.row.status!=4" icon="el-icon-delete">删除</el-button>
                        <el-button type="text"  @click="commodityDetail( scope.row)">详情</el-button>
                        <el-button type="text" v-if="scope.row.status===4" @click="setCommodityPic(scope.row.id)">上传商品图片</el-button>
                        <el-button type="text" v-if="scope.row.status===4" @click="updateCommodityPic(scope.row.id)">修改商品图片</el-button>
                        <el-button type="text" v-if="scope.row.status===4" @click="deleteCommodityPic(scope.row.id,true)">删除商品图片</el-button>
                        <!-- <el-button
              type="text"
              @click="editCommodity(scope.$index, scope.row)"
              v-if="scope.row.status!=4"
              icon="el-icon-edit"
            >编辑</el-button> -->
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </div>

      <el-dialog title ="上传图片" :visible.sync="uploadPicVisible" width="300px" :close-on-click-modal="false">
        <el-upload
          ref="upload"
          :action="addFile"
          :on-change="handleOnChange1"
          :file-list="addProductPackageImgList"
          :limit="5"
          :on-exceed="uploadOverrun"
          :auto-upload="false"
          :on-remove="handleRemove1"
          accept=".jpg, .jpeg, .png, .gif"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-dialog>
        <!-- 新增商品 -->
        <el-dialog title="新建商品" :visible.sync="addCommodityVisible" width="1000px" center>
            <div style="min-height:400px;">
                <el-steps :active="activeStep" finish-status="success" simple style="margin-top: 20px">
                    <el-step title="选择商品类型"></el-step>
                    <el-step title="完善商品信息"></el-step>
                    <el-step title="确认商品规格"></el-step>
                    <el-step title="完成创建"></el-step>
                </el-steps>
                <!-- 第一步 -->
                <div v-if="activeStep==1" style="display:flex;align-items:center;justify-content:center;height:300px; width:900px;">
                    <el-form ref="stepOneForm" :rules="stepOneFormRules" :model="stepOneForm" style="width:900px;text-align:center" :inline="true">
                        <el-form-item label="选择商品套餐类型" prop="type">
                            <el-select v-model="stepOneForm.type" placeholder="请选择商品套餐类型" clearable>

                                <el-option :value="2" label="单品"></el-option>
                                <el-option :value="1" label="套餐"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 第二步 -->
                <div v-if="activeStep==2" style="padding:20px;">
                    <!-- 单品 -->
                    <div v-if="stepOneForm.type==2">
                        <el-form ref="stepTwoForm" :rules="stepTwoFormRules" :model="stepTwoForm" label-width="100px" size="medium">
                            <el-row>
                                <!-- <el-col :span="12">
                    <el-form-item label="选择城市" prop="cityId">
                  <el-select v-model="stepTwoForm.cityId" placeholder="请选择城市" clearable multiple>
                     <el-option
                v-for="(item,index) in cityList"
                :key="index"
                :label="item.cityName"
                :value="item.id+''"

              ></el-option>
                  </el-select>
                </el-form-item>
                 </el-col> -->
                                <el-col :span="12">
                                    <el-form-item label="选择类目" prop="categoryId">
                                        <el-cascader v-model="stepTwoForm.categoryId" :options="categoryList" :props="{ expandTrigger: 'hover',value:'id',label: 'categoryName',
          children: 'childCategorys'}" clearable :show-all-levels="false" placeholder="请选择类目" @change="categoryChange"></el-cascader>
                                    </el-form-item>
                                </el-col>

                            </el-row>

                            <el-row>
                                <!-- <el-col :span="12">
                    <el-form-item label="预计库存数" prop="predictStockCount">
                       <el-input v-model="stepTwoForm.predictStockCount" placeholder="请输入预计库存数" clearable></el-input>
                    </el-form-item>
                 </el-col> -->
                                <el-col :span="12">
                                    <el-form-item label="商品品牌" prop="brandId">
                                        <el-select v-model="stepTwoForm.brandId" placeholder="请选择商品品牌" clearable filterable>
                                            <el-option v-for="(item,index) in brandList" :key="index" :label="item.brandName" :value="item.id"></el-option>
                                        </el-select>

                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="商品名称" prop="commodityName">
                                        <el-input v-model="stepTwoForm.commodityName" placeholder="请输入商品名称" clearable></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <el-row>

                                <el-col :span="12">
                                    <el-form-item label="销售类型" prop="salesType">
                                        <el-radio-group v-model="stepTwoForm.salesType">
                                            <el-radio :label="1">租赁</el-radio>
                                            <el-radio :label="2">售卖</el-radio>
                                            <el-radio :label="3">租售</el-radio>
                                            <el-radio :label="4">补贴领用</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="商品规格" prop="relationAttributes">
                                        <el-select v-model="stepTwoForm.relationAttributes" placeholder="请选择商品规格" clearable multiple @change="attrChange">
                                            <el-option v-for="(item,index) in propertyBindList" :key="index" :label="item.propertyName" :value="item.attributeId"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                            </el-row>

                            <!-- <el-row>
                 <el-col :span="12" v-if="stepTwoForm.salesType!=2">
                    <el-form-item label="租赁价格" prop="rentPrice">
                       <el-input v-model="stepTwoForm.rentPrice" placeholder="请输入租赁价格" clearable></el-input>
                    </el-form-item>
                 </el-col>
                 <el-col :span="12" v-if="stepTwoForm.salesType!=1">
                    <el-form-item label="售卖价格" prop="salePrice">
                       <el-input v-model="stepTwoForm.salePrice" placeholder="请输入售卖价格" clearable></el-input>
                    </el-form-item>
                 </el-col>
              </el-row> -->
                            <!-- 规格 -->
                            <el-row>

                            </el-row>
                            <el-table :data="propertyCheckList" border style="width:600px;margin:0 20px 20px 30px">
                                <el-table-column prop="propertyName" label="规格名称" width="200"></el-table-column>
                                <el-table-column label="规格值" align="center">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.propertyValue" placeholder="请输入规格值" v-if="scope.row.inputType==0"></el-input>
                                        <!-- 多选 -->
                                        <el-checkbox-group v-model="scope.row.propertyValue" v-if="scope.row.inputType==1&&scope.row.multipleChoice==1">
                                            <el-checkbox :label="item" v-for="(item,index) in scope.row.inputScope.split(',')" :key="index"></el-checkbox>
                                        </el-checkbox-group>
                                        <!-- 单选 -->
                                        <el-radio-group v-model="scope.row.propertyValue" v-if="scope.row.inputType==1&&scope.row.multipleChoice==0">
                                            <el-radio :label="item" v-for="item in scope.row.inputScope.split(',')" :key="item"></el-radio>
                                        </el-radio-group>
                                    </template>

                                </el-table-column>
                            </el-table>

                            <el-row>
                                <el-col>
                                    <el-form-item label="商品描述" prop="type">
                                        <el-input type="textarea" style="width:600px" :rows="3" placeholder="请输入商品描述" v-model="stepTwoForm.detailDesc"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-form-item label="商品图片:"></el-form-item>
                                <el-upload :action="addFile" :on-change="handleOnChange" :file-list="addProductImgList" :limit="5" :on-exceed="uploadOverrun" :auto-upload="false" :on-remove="handleRemove" accept=".jpg, .jpeg, .png, .gif" list-type="picture-card">
                                    <i class="el-icon-plus" />
                                </el-upload>
                            </el-row>

                        </el-form>
                    </div>

                    <!-- 套餐 -->
                    <div v-if="stepOneForm.type==1">

                        <el-form ref="stepTwoPackageForm" :rules="stepTwoPackageFormRules" :model="stepTwoPackageForm" label-width="100px" size="medium">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="选择城市" prop="cityId">
                                        <el-select v-model="stepTwoPackageForm.cityId" placeholder="请选择城市" clearable multiple>
                                            <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id+''"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="套餐包名称" prop="commodityName">
                                        <el-input v-model="stepTwoPackageForm.commodityName" placeholder="请输入商品名称" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>

                                <el-col :span="12">
                                    <el-form-item label="销售类型" prop="salesType">
                                        <el-radio-group v-model="stepTwoPackageForm.salesType">
                                            <el-radio :label="1">租赁</el-radio>
                                            <el-radio :label="2">售卖</el-radio>
                                            <el-radio :label="3">租赁和售卖</el-radio>
                                            <el-radio :label="4">补贴领用</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="预计库存数" prop="predictStockCount">
                                        <el-input v-model="stepTwoPackageForm.predictStockCount" placeholder="请输入预计库存数" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="12" v-if="stepTwoPackageForm.salesType==1||stepTwoPackageForm.salesType==3">
                                    <el-form-item label="租赁价格" prop="rentPrice">
                                        <el-input v-model="stepTwoPackageForm.rentPrice" placeholder="请输入租赁价格" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" v-if="stepTwoPackageForm.salesType==1||stepTwoPackageForm.salesType==3">
                                    <el-form-item label="押金" prop="deposit">
                                        <el-input v-model="stepTwoPackageForm.deposit" placeholder="请输入押金" clearable></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <el-row>
                                <el-col :span="12" v-if="stepTwoPackageForm.salesType==2||stepTwoPackageForm.salesType==3">
                                    <el-form-item label="售卖价格" prop="salePrice">
                                        <el-input v-model="stepTwoPackageForm.salePrice" placeholder="请输入售卖价格" clearable></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <el-row>
                                <el-col>
                                    <el-form-item label="套餐包描述" prop="type">
                                        <el-input type="textarea" style="width:600px" :rows="3" placeholder="请输入套餐包描述" v-model="stepTwoPackageForm.detailDesc"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <!-- <el-row>
          <el-form-item label="套餐包图片:"></el-form-item>
           <el-upload
          :action="addFile"
          :on-change="handleOnChange1"
          :file-list="addProductPackageImgList"
          :limit="5"
          :on-exceed="uploadOverrun"
          :auto-upload="false"
          :on-remove="handleRemove1"
          accept=".jpg, .jpeg, .png, .gif"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
        </el-upload>
        </el-row> -->

                        </el-form>
                        <!-- 套餐包组成 -->
                        <div style="padding:20px;border:1px solid #ddd;">
                            <h4>套餐包组成</h4>
                            <el-form :inline="true" class="demo-form-inline">
                                <el-form-item label="商品名称">
                                    <el-input v-model="productQuery.commodityName" placeholder="请输入商品名称" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="商品编码">
                                    <el-input v-model="productQuery.spuCode" placeholder="请输入商品编码" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="品牌名称">
                                    <el-input v-model="productQuery.brandName" placeholder="请输入品牌名称" clearable></el-input>
                                </el-form-item>
                                 <el-form-item label="售卖类型">
                            <el-select v-model="productQuery.salesType" multiple placeholder="请选择商品类型" clearable>
                                <!-- <el-option label="租借" :value="1+''"></el-option> -->
                                <el-option  label="售卖" :value="2+''"></el-option>
                                <el-option  label="租借和售卖" :value="3+''"></el-option>
                            </el-select>
                        </el-form-item>
                                <el-form-item label="商品类目">
                                    <el-cascader v-model="productQuery.categoryId" :options="categoryList" :props="{ expandTrigger: 'hover',value:'id',label: 'categoryName',
          children: 'childCategorys'}" clearable :show-all-levels="false" size="mini"></el-cascader>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="el-icon-search" @click="productSearch">搜索</el-button>
                                </el-form-item>
                            </el-form>

                            <el-table :data="addProductQueryShow" border class="table" max-height="320" ref="multipleTable">
                                <el-table-column prop="commodityName" label="商品名称" width="100" fixed="left"></el-table-column>
                                <el-table-column prop="spuCode" label="商品编码"></el-table-column>
                                <el-table-column prop="categoryName" label="商品类目"></el-table-column>
                                <el-table-column prop="brandName" label="品牌"></el-table-column>
                                <el-table-column prop="salesType" label="销售类型">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.salesType == 1">租借</span>
                                        <span v-if="scope.row.salesType == 2">售卖</span>
                                        <span v-if="scope.row.salesType == 3">租借和售卖</span>
                                        <span v-if="scope.row.salesType == 4">补贴领用</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="satus" label="商品状态">
                                    <template slot-scope="scope">{{scope.row.status | statusFilter}}</template>
                                </el-table-column>
                                <el-table-column prop="detail.detailDesc" label="商品详情描述"></el-table-column>
                                <el-table-column label="组成数量" align="center" width="100">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.materNum" type="number" @mousewheel.native.prevent></el-input>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="name" label="操作" width="55">
                                    <template slot-scope="scope">
                                        <el-button @click="addConfirm(scope.row)" type="text" size="small">添加</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <p style="margin:10px 0;">已选商品：</p>
                            <el-table :data="addPackageInfo" class="table">
                                <el-table-column prop="commodityName" label="商品名称" width="100" fixed="left"></el-table-column>
                                <el-table-column prop="spuCode" label="商品编码"></el-table-column>
                                <el-table-column prop="categoryName" label="商品类目"></el-table-column>
                                <el-table-column prop="brandName" label="品牌"></el-table-column>
                                <el-table-column prop="salesType" label="销售类型">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.salesType == 1">租借</span>
                                        <span v-if="scope.row.salesType == 2">售卖</span>
                                        <span v-if="scope.row.salesType == 3">租借和售卖</span>
                                        <span v-if="scope.row.salesType == 4">补贴领用</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="satus" label="商品状态">
                                    <template slot-scope="scope">{{scope.row.status | statusFilter}}</template>
                                </el-table-column>
                                <el-table-column prop="detail.detailDesc" label="商品详情描述"></el-table-column>
                                <el-table-column label="组成数量" align="center" width="100">
                                    <template slot-scope="scope">
                                        <el-input v-model.trim="scope.row.materNum" type="number" @mousewheel.native.prevent></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="name" label="操作" width="55">
                                    <template slot-scope="scope">
                                        <el-button @click="delMat(scope.row)" type="text" size="small">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>

                        </div>

                    </div>
                </div>

                <!-- 第三步 完善规格 -->
                <div v-if="activeStep==3" style="padding:20px 0px;">
                    <!-- 单品 -->
                    <div v-if="stepOneForm.type==2">

                        <el-table :data="skuList" border style="width:900px;margin:0 10px 20px 10px" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="40"></el-table-column>
                            <el-table-column prop="skuProperty" label="规格名称"></el-table-column>
                            <el-table-column prop="skuCode" label="skuCode"></el-table-column>
                            <el-table-column label="货号-批次号" align="center" prop="articleNumber">
                                <template slot-scope="scope">
                                    <el-input v-model.trim="scope.row.articleNumber" placeholder="请输入货号-批次号"></el-input>

                                </template>

                            </el-table-column>
                            <el-table-column label="预计库存数" align="center" prop="predictStockCount">
                                <template slot-scope="scope">
                                    <el-input v-model.trim="scope.row.predictStockCount" placeholder="请输入预计库存数"></el-input>

                                </template>

                            </el-table-column>
                            <el-table-column label="销售价格" align="center" prop="salePrice" v-if="stepTwoForm.salesType!=1">
                                <template slot-scope="scope">
                                    <el-input v-model.trim="scope.row.salePrice" placeholder="请输入销售价格"></el-input>

                                </template>

                            </el-table-column>
                            <el-table-column label="租赁价格" align="center" prop="rentPrice" v-if="stepTwoForm.salesType!=2">
                                <template slot-scope="scope">
                                    <el-input v-model.trim="scope.row.rentPrice" placeholder="请输入租赁价格"></el-input>

                                </template>

                            </el-table-column>
                            <el-table-column label="押金" align="center" prop="deposit" v-if="stepTwoForm.salesType!=2">
                                <template slot-scope="scope">
                                    <el-input v-model.trim="scope.row.deposit" placeholder="请输入押金"></el-input>
                                </template>
                            </el-table-column>

                            <el-table-column label="可租时长/月" align="center" prop="leaseTime" v-if="stepTwoForm.salesType!=2">
                                <template slot-scope="scope">
                                    <el-input v-model.trim="scope.row.leaseTime" placeholder="请输入可租时长"></el-input>
                                </template>
                            </el-table-column>

                        </el-table>

                    </div>
                    <!-- 套餐 -->
                    <div v-if="stepOneForm.type==1">

                    </div>
                </div>
                <!-- 第四步 -->

                <div v-if="activeStep==4" style="padding:100px 0 0;text-align:center;">
                    <i class="el-icon-circle-check" style="color:#409eff;font-size:60px;"></i>
                    <p style="font-size:18px;margin-top:20px;">恭喜您，创建成功</p>

                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="activeStep>1" @click="lastStep">上一步</el-button>
                <el-button type="primary" @click="nextStep">
                    <span v-if="activeStep!=4">下一步</span>
                    <span v-if="activeStep==4">完成创建</span>
                </el-button>
            </span>
        </el-dialog>

        <!-- 商品详情 -->

        <el-dialog title="商品详情" :visible.sync="detailVisable" width="1200px" :close-on-click-modal="false" center>
            <el-row v-if="tempRow.type==1" style="color:red;font-size:16px;">套餐名称：{{tempRow.commodityName}}  &nbsp;&nbsp;套餐价格：{{tempRow.childCommoditys.salePrice}}元</el-row>
            <el-table :data="detailList" border style="width: 100%" class="table" fit v-if="detailType=='2'">
                <el-table-column prop="skuCode" label="sku编码" fixed="left"></el-table-column>
                <el-table-column prop="supportFraBuy" label="是否透出给加盟商" fixed="left">
                    <template slot-scope="scope">
                        <span v-if="scope.row.supportFraBuy == 1">是</span>
                        <span v-if="scope.row.supportFraBuy == 0">否</span>
                    </template>
                </el-table-column>
              <el-table-column prop="fraPrice" label="对加盟商售价" fixed="left"></el-table-column>
                <el-table-column prop="propertyValue" label="规格名称"></el-table-column>
                <el-table-column prop="predictStockCount" label="预计库存数"></el-table-column>
                <el-table-column prop="articleNumber" label="货号-批次号"></el-table-column>
                <el-table-column prop="salePrice" label="销售价格"></el-table-column>
                <el-table-column prop="rentPrice" label="租赁价格"></el-table-column>
                <el-table-column prop="deposit" label="押金"></el-table-column>
                <el-table-column prop="leaseTime" label="总可租赁时长/月"></el-table-column>
              <el-table-column prop="" label="操作" fixed="right" width="180px" align="center">
                <!--                    v-per="'setSkuOpenToFranchiseeAndPrice'"
                    v-per="'setSkuOpenToFranchiseeAndPrice'"
                -->
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    v-if="scope.row.supportFraBuy !== 1"
                    @click="setSkuOpenToFranchiseeAndPrice(scope.row)"
                    size="mini"
                  >对加盟商开放销售</el-button>
                  <el-button
                    v-if="scope.row.supportFraBuy == 1"
                    type="text"
                    @click="deleteOpen2Fra(scope.row)"
                    size="mini"
                  >不对加盟商开放售卖</el-button>

                </template>
              </el-table-column>

            </el-table>
            <el-table :data="detailList" border style="width: 100%" class="table" fit v-else>
                <el-table-column prop="spuInfo.commodityName" label="商品名称" fixed="left"></el-table-column>
                <el-table-column prop="childSpuCount" label="组成数量"></el-table-column>
                <el-table-column prop="spuInfo.spuCode" label="商品编码"></el-table-column>
                <el-table-column prop="spuInfo.commodityName" label="商品类目"></el-table-column>
                <el-table-column prop="spuInfo.brandName" label="品牌"></el-table-column>
                <el-table-column prop="salesType" label="销售类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.spuInfo.salesType == 1">租借</span>
                        <span v-if="scope.row.spuInfo.salesType == 2">售卖</span>
                        <span v-if="scope.row.spuInfo.salesType == 3">租借和售卖</span>
                        <span v-if="scope.row.spuInfo.salesType == 4">补贴领用</span>
                    </template>
                </el-table-column>
                <el-table-column prop="satus" label="商品状态">
                    <template slot-scope="scope">{{scope.row.spuInfo.status | statusFilter}}</template>
                </el-table-column>
                <el-table-column prop="spuInfo.detail.detailDesc" label="商品详情描述"></el-table-column>

            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button @click=" detailVisable=false" type="primary">关闭</el-button>
            </span>
        </el-dialog>

      <el-dialog title="设置加盟商购买价格" :visible.sync="showOpen2Fra" width="400px" :close-on-click-modal="false" center>
        <el-form :inline="true">
          <el-form-item label="加盟商售价" aria-placeholder="可选，不设置默认高出市场销售价10%">
            <el-input v-model="open2FraForm.franchiseePrice" placeholder="加盟商售价"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
                <el-button @click="showOpen2Fra=false">关闭</el-button>
                <el-button type="primary" @click="confirmInput">确定</el-button>
            </span>
      </el-dialog>

    </div>
</template>

<script>
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import Service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";

let vm;
export default {
    components: { Pagination },
    filters: {
        statusFilter(value) {
          console.log("filter value:"+value);
            const rs = vm.statusList.filter((item) => {
                return item.id === value;
            });

            if (rs != null && rs.length > 0) {
                return rs[0].text;
            }
        },
    },
    data() {
        return {
            uploadPicVisible:false,
            addFile: Service.addFile + globalData.userInfo.userAccount,
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            stopUseMatName: "",
            tableData: [],
            listQuery: {
                type: "",
                salesType: "",
                status: "",
                commodityName: "",
                spuCode: "",
                brandName: "",
                categoryId: "",
                timePart: [],
            },
            statusList: [
                // {
                //   id: 0,
                //   text: "编辑中"
                // },
                {
                    id: 1,
                    text: "待审核",
                },
                {
                    id: 2,
                    text: "待上架",
                },
                {
                    id: 3,
                    text: "审核不通过",
                },
                {
                    id: 4,
                    text: "上架中",
                },
                {
                    id: 5,
                    text: "已下架",
                },
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近半个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 15
                            );
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
            categoryList: [],
            addCommodityVisible: false,
            activeStep: 1,
            stepOneForm: {
                type: 2, //1套餐 2单品
            },
            stepOneFormRules: {
                type: [
                    {
                        required: true,
                        message: "请选择商品类型",
                        trigger: "blur",
                    },
                ],
            },
            cityList: [],
            stepTwoForm: {
                commodityName: "",
                //  cityId:[],
                categoryId: "",
                predictStockCount: "",
                brandId: "",
                salesType: 1,
                rentPrice: "",
                salePrice: "",
                relationAttributes: [],
                detailDesc: "",
            },
            stepTwoFormRules: {
                cityId: [
                    { required: true, message: "请选择城市", trigger: "blur" },
                ],
                categoryId: [
                    { required: true, message: "请选择类目", trigger: "blur" },
                ],
                commodityName: [
                    {
                        required: true,
                        message: "请输入商品名称",
                        trigger: "blur",
                    },
                ],
                predictStockCount: [
                    {
                        required: true,
                        message: "请输入预计库存数",
                        trigger: "blur",
                    },
                ],
                brandId: [
                    {
                        required: true,
                        message: "请选择商品品牌",
                        trigger: "blur",
                    },
                ],
                salesType: [
                    {
                        required: true,
                        message: "请选择销售类型",
                        trigger: "blur",
                    },
                ],
                rentPrice: [
                    {
                        required: true,
                        message: "请输入租赁价格",
                        trigger: "blur",
                    },
                ],
                salePrice: [
                    {
                        required: true,
                        message: "请输入售卖价格",
                        trigger: "blur",
                    },
                ],
                relationAttributes: [
                    {
                        required: true,
                        message: "请选择商品规格",
                        trigger: "blur",
                    },
                ],
            },
            stepTwoPackageForm: {
                cityId: [],
                commodityName: "",
                salesType: 1,
                rentPrice: "",
                salePrice: "",
                detailDesc: "",
            },
            stepTwoPackageFormRules: {
                cityId: [
                    { required: true, message: "请选择城市", trigger: "blur" },
                ],
                commodityName: [
                    {
                        required: true,
                        message: "请输入套餐包名称",
                        trigger: "blur",
                    },
                ],
                salesType: [
                    {
                        required: true,
                        message: "请选择销售类型",
                        trigger: "blur",
                    },
                ],
                predictStockCount: [
                    {
                        required: true,
                        message: "请输入预计库存数",
                        trigger: "blur",
                    },
                ],
                rentPrice: [
                    {
                        required: true,
                        message: "请输入租赁价格",
                        trigger: "blur",
                    },
                ],
                salePrice: [
                    {
                        required: true,
                        message: "请输入售卖价格",
                        trigger: "blur",
                    },
                ],
                deposit: [
                    { required: true, message: "请输入押金", trigger: "blur" },
                ],
                leaseTime: [
                    {
                        required: true,
                        message: "请输入可租月份",
                        trigger: "blur",
                    },
                ],
            },
            addProductImgList: [],
            addProductPackageImgList: [],
            brandList: [],
            propertyBindList: [],
            propertyCheckList: [],
            skuList: [],
            multipleSelection: [],
            productQuery: {
                commodityName: "",
                spuCode: "",
                brandName: "",
                categoryId: "",
                salesType:[],
            },
            addProductQueryShow: [],
            addPackageInfo: [],
            detailList: [],
            detailVisable: false,
            detailType: 2,
            tempRow:{},
            tempCommodityId:"",
            showOpen2Fra:false,
            open2FraForm:{
              skuId:null,
              franchiseePrice:"",
            },
        };
    },
    beforeCreate() {
        vm = this;
    },
    created() {
        this.querySearch();
        wmsApi
            .$axiosCategoryTree({})
            .then((res) => {
                this.categoryList = res.data.data;
            })
            .catch((err) => {
                console.log(err);
            });
        wmsApi
            .$axiosBrandList({ page: 1, size: 1000, isEnabled: "true" })
            .then((res) => {
                this.brandList = res.data.data.list;
            })
            .catch((err) => {
                console.log(err);
            });
        this.getAllStationList();
    },
    methods: {
      setSkuOpenToFranchiseeAndPrice(row){
        this.showOpen2Fra=true;
        this.open2FraForm.skuId=row.id;
      },
      confirmInput() {
        if(this.open2FraForm.franchiseePrice==""){
          this.$message.error("请输入加盟商售价");
          return;
        }
        wmsApi
          .$axiosSetSkuOpenToFranchiseeAndPrice({
            skuId: this.open2FraForm.skuId,
            franchiseePrice: this.open2FraForm.franchiseePrice,
          })
          .then((res) => {
            if (res.data.errno == 0) {
              this.$message.success("设置成功");
              this.showOpen2Fra = false;
              this.commodityDetail(this.tempRow);
            }else{
              this.$message.error(res.data.errmsg);
            }
          });
      },

      deleteOpen2Fra(row) {
        this.$confirm("确定要取消该商品sku对加盟商销售吗?", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          wmsApi
            .$axiosDeleteOpen2Fra({
              skuId: row.id,
            })
            .then((res) => {
              if (res.data.errno == 0) {
                this.$message.success("取消成功");
                this.commodityDetail(this.tempRow);
              }
            });
        });
      },
      clearFileHistory(){
        this.$refs.upload.clearFiles();
      },
      deleteCommodityPic(id,Alert){
       if(Alert){
         this.$confirm("确定要删除商品图片吗?", "警告", {
           confirmButtonText: "确定",
           cancelButtonText: "取消",
           type: "warning",
         }).then(() => {
           wmsApi
             .$axiosDeleteCommodityImage({commodityId:id})
             .then(
               (res) => {
                 if(res.data.errno===0) {
                   this.$message.success("删除成功");
                   this.querySearch();
                 }
               }
             ).catch((err) => {
               console.log(err);
             });
           this.querySearch();
         }).catch(() => {
           this.$message({
             type: "info",
             message: "已取消删除"
           });
         });
       }else{
         wmsApi
           .$axiosDeleteCommodityImage({commodityId:id})
           .then(
             (res) => {
               if(res.data.errno===0) {
                 this.querySearch();
               }else {
                 this.$message.error("删除失败");
               }}
           ).catch((err) => {
             console.log(err);
           });
       }


      },
      updateCommodityPic(id){
        this.$confirm("确定要修改商品图片吗?", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.deleteCommodityPic(id,false);
          this.uploadPicVisible=true;
          this.tempCommodityId=id;
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
      },
      setCommodityPic(id){
        this.uploadPicVisible=true;
        this.tempCommodityId=id;
       },


        //获取数据
        querySearch() {
            let temp = {
                page: this.currentPage,
                size: this.pageSize,
                type: this.listQuery.type,
                salesType: this.listQuery.salesType,
                commodityName: this.listQuery.commodityName,
                brandName: this.listQuery.brandName,
                categoryId:
                    this.listQuery.categoryId.length >= 3
                        ? this.listQuery.categoryId[2]
                        : "",
                spuCode: this.listQuery.spuCode,
                status: this.listQuery.status,
            };
            if (
                this.listQuery.timePart != "" &&
                this.listQuery.timePart != undefined
            ) {
                temp.createTimeStart = this.listQuery.timePart[0]
                    .getTime()
                    .toString()
                    .substr(0, 10);
                temp.createTimeEnd = this.listQuery.timePart[1]
                    .getTime()
                    .toString()
                    .substr(0, 10);
            }
            wmsApi
                .$axiosCommodityList(temp)
                .then((res) => {
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.total;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        ableCommodity(row) {
            this.$confirm("确定上架该商品吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    wmsApi
                        .$axiosAbleCommodity({
                            commodityId: row.id,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("上架成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => {});
        },
        disableCommodity(row) {
            this.$confirm("确定下架该商品吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    wmsApi
                        .$axiosDisableCommodity({
                            commodityId: row.id,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("下架成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => {});
        },
        deleteCommodity(row) {
            this.$confirm("确定删除该商品吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    wmsApi
                        .$axiosDeleteCommodity({
                            commodityId: row.id,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("删除成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => {});
        },
        editCommodity(row) {},
        picListFormat(arr) {
            let picList = arr.map((item) => {
                return item.picAddress;
            });
            return picList;
        },
        addCommodity() {
            this.activeStep = 1;
            this.stepOneForm = {
                type: 2,
            };
            (this.stepTwoForm = {
                commodityName: "",
                categoryId: "",
                predictStockCount: "",
                brandId: "",
                salesType: 1,
                rentPrice: "",
                salePrice: "",
                relationAttributes: [],
                detailDesc: "",
            }),
                (this.stepTwoPackageForm = {
                    cityId: [],
                    commodityName: "",
                    salesType: 1,
                    rentPrice: "",
                    salePrice: "",
                    detailDesc: "",
                }),
                (this.addProductImgList = []);
                 this.propertyCheckList = [];
            this.propertyBindList = [];
            this.addCommodityVisible = true;
        },
        getAllStationList() {
            wmsApi
                .$axiosCityStationGetAll({})
                .then((res) => {
                    this.cityList = res.data.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleOnChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (file.raw) {
                console.log("上传文件大小" + file.raw.size);
                let param = new FormData();
                param.append("createAccount", globalData.userInfo.userAccount);
                param.append("file", file.raw);
                Service.$ajaxAddFile(param).then((res) => {
                    console.log(res);
                    if (res.data.errno == 0) {
                        console.log(res);
                        file.url = res.data.data.fileUrl;
                        this.addProductImgList = fileList;
                        console.log(this.addProductImgList);
                    }
                });
            }
        },
        handleOnChange1(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (file.raw) {
                console.log("上传文件大小" + file.raw.size);
                let param = new FormData();
                param.append("createAccount", globalData.userInfo.userAccount);
                param.append("file", file.raw);
                Service.$ajaxAddFile(param).then((res) => {
                    console.log(res);
                    if (res.data.errno == 0) {
                        console.log(res);
                        file.url = res.data.data.fileUrl;
                        this.addProductPackageImgList = fileList;
                        console.log(this.addProductPackageImgList);
                        let pic =res.data.data.fileUrl;
                        wmsApi.$axiosUploadCommodityImage({
                        commodityId:this.tempCommodityId,
                        picAddress: {pic}
                      }).then(()=>{
                        this.$message.success("上传成功");
                        this.clearFileHistory();
                        this.uploadPicVisible=false;
                        this.tempCommodityId=null;
                        this.querySearch();
                      }).catch(err=>{
                        console.log(err);
                      })
                    }
                });
            }
        },
        uploadOverrun: function () {
            this.$message({
                type: "error",
                message: "上传文件个数超出限制!最多上传5张图片!",
            });
        },
        handleRemove: function (file, fileList) {
            console.log(file, fileList);
            this.addProductImgList = fileList;
        },
        handleRemove1: function (file, fileList) {
            console.log(file, fileList);
            this.addProductPackageImgList = fileList;
        },
        categoryChange(value) {
            this.propertyCheckList = [];
            this.propertyBindList = [];
            this.stepTwoForm.relationAttributes = [];
            if (value.length >= 3) {
                wmsApi
                    .$axiosPropertyBindRelationByCategoryId({
                        categoryId: value[2],
                    })
                    .then((res) => {
                        if (res.data.errno == 0) {
                            this.propertyBindList = res.data.data;
                        }
                    });
            }
        },
        attrChange(value) {
            if (value.length >= 1) {
                let list = [];
                value.forEach((item) => {
                    let current = this.propertyBindList.filter((pro) => {
                        return pro.attributeId == item;
                    });
                    list.push(current[0]);
                });
                list.map((item) => {
                    if (item.inputType == 1 && item.multipleChoice == 1) {
                        item.propertyValue = [];
                    } else {
                        item.propertyValue = "";
                    }
                });
                this.propertyCheckList = list;
            } else {
                this.propertyCheckList = [];
            }
        },

        lastStep() {
            this.activeStep = this.activeStep - 1;
            console.log(this.propertyCheckList);
        },
        nextStep() {
            if (this.activeStep == 1) {
                this.$refs["stepOneForm"].validate((valid) => {
                    if (valid) {
                        this.activeStep = 2;
                        if (this.stepOneForm.type == 1) {
                            // 新增套餐包时
                            this.productSearch();
                        }
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            } else if (this.activeStep == 2 && this.stepOneForm.type == 2) {
                this.$refs["stepTwoForm"].validate((valid) => {
                    if (valid) {
                        let imgUrl = this.addProductImgList.map((item) => {
                            return item.url;
                        });
                        console.log(this.propertyCheckList);
                        // let proList=this.propertyCheckList;
                        let isEmpty = this.propertyCheckList.some((item) => {
                            return item.propertyValue == "";
                        });
                        if (isEmpty) {
                            this.$message.warning("规格值不能为空");
                            return false;
                        }
                        let proList = JSON.parse(
                            JSON.stringify(this.propertyCheckList)
                        );

                        proList.map((item) => {
                            if (
                                item.multipleChoice == 1 &&
                                item.inputType == 1
                            ) {
                                item.propertyValue =
                                    item.propertyValue.join(",");
                            }
                        });

                        let params = {
                            type: 2,
                            commodityName: this.stepTwoForm.commodityName,
                            //  cityId:this.stepTwoForm.cityId.join(','),
                            categoryId:
                                this.stepTwoForm.categoryId.length >= 3
                                    ? this.stepTwoForm.categoryId[2]
                                    : "",
                            brandId: this.stepTwoForm.brandId,
                            salesType: this.stepTwoForm.salesType,
                            detailDesc: this.stepTwoForm.detailDesc,
                            relationAttributes: proList,
                            picAddresses: imgUrl,
                            //  predictStockCount:this.stepTwoForm.predictStockCount,
                            //  rentPrice:this.stepTwoForm.rentPrice,
                            //  salePrice:this.stepTwoForm.salePrice,
                        };
                        wmsApi
                            .$axiosAddCommodity(params)
                            .then((res) => {
                                this.activeStep = 3;
                                this.skuList = res.data.data;
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            } else if (this.activeStep == 2 && this.stepOneForm.type == 1) {
                // 第二步套餐包
                this.$refs["stepTwoPackageForm"].validate((valid) => {
                    if (valid) {
                        if (this.addPackageInfo.length == 0) {
                            this.$message.warning("套餐包组成不能为空");
                            return false;
                        }
                        let isNumValid = this.addPackageInfo.some((item) => {
                            return item.materNum == "" || item.materNum <= 0;
                        });
                        if (isNumValid) {
                            this.$message.warning(
                                "套餐包组成数量不能为空和负数"
                            );
                            return false;
                        }
                        let list = [];
                        this.addPackageInfo.forEach((item) => {
                            let obj = {
                                spuId: item.id,
                                num: item.materNum,
                            };
                            list.push(obj);
                        });
                        let params = {
                            type: 1,
                            commodityName:
                                this.stepTwoPackageForm.commodityName,
                            cityId: this.stepTwoPackageForm.cityId.join(","),
                            salesType: this.stepTwoPackageForm.salesType,
                            detailDesc: this.stepTwoPackageForm.detailDesc,
                            relationSpus: list,
                            rentPrice:
                                this.stepTwoPackageForm.salesType != 2
                                    ? this.stepTwoPackageForm.rentPrice
                                    : "",
                            deposit:
                                this.stepTwoPackageForm.salesType != 2
                                    ? this.stepTwoPackageForm.deposit
                                    : "",
                            salePrice:
                                this.stepTwoPackageForm.salesType != 1
                                    ? this.stepTwoPackageForm.salePrice
                                    : "",
                            predictStockCount:
                                this.stepTwoPackageForm.predictStockCount,
                            //  picAddresses:imgUrl
                            //  predictStockCount:this.stepTwoForm.predictStockCount,
                        };
                        wmsApi
                            .$axiosAddCommodity(params)
                            .then((res) => {
                                this.activeStep = 4;
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            } else if (this.activeStep == 3) {
                if (this.multipleSelection.length == 0) {
                    this.$message.warning("请确认商品规格");
                    return false;
                }
                let isEmpty = this.multipleSelection.some((item) => {
                    return item.predictStockCount == "";
                });
                if (isEmpty) {
                    this.$message.warning("预计库存数不能为空");
                    return false;
                }

                wmsApi
                    .$axiosCompleteCommoditySKU(this.multipleSelection)
                    .then((res) => {
                        this.activeStep = 4;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else if (this.activeStep == 4) {
                this.addCommodityVisible = false;
                this.querySearch();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        productSearch() {
            let temp = {
                page: 1,
                size: 1000,
                type: 2,
                status: 4,
                commodityName: this.productQuery.commodityName,
                brandName: this.productQuery.brandName,
                categoryId:
                    this.productQuery.categoryId.length >= 3
                        ? this.productQuery.categoryId[2]
                        : "",
                spuCode: this.productQuery.spuCode,
                salesType:this.productQuery.salesType.join(','),

            };
            // if (this.stepOneForm.type == 1) {
            //     //套餐
            //     if (this.stepTwoPackageForm.salesType == 1) {
            //         temp.salesType = "1,3";
            //     }
            //     if (this.stepTwoPackageForm.salesType == 2) {
            //         temp.salesType = "2,3";
            //     }
            //     if (this.stepTwoPackageForm.salesType == 3) {
            //         temp.salesType = "3";
            //     }
            //     if (this.stepTwoPackageForm.salesType == 4) {
            //         temp.salesType = "4";
            //     }
            // }
            wmsApi
                .$axiosCommodityList(temp)
                .then((res) => {
                    this.addProductQueryShow = res.data.data.list;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        addConfirm(row) {
            if (row.materNum <= 0) {
                this.$message.warning("组成数量不能为负数！");
                return;
            }
            if (row.materNum == undefined || row.materNum == "") {
                this.$message.warning("请填写数量");
                return;
            }
            let packageItem = row;
            let isNew = this.addPackageInfo.every((item) => {
                return item.id != row.id;
            });
            if (isNew) {
                this.addPackageInfo.push(row);
            } else {
                this.$message.warning("该商品已经被添加");
                return;
            }
        },
        delMat(row) {
            console.log(this.addPackageInfo);
            for (let i = 0; i < this.addPackageInfo.length; i++) {
                if (row.id == this.addPackageInfo[i].id) {
                    this.addPackageInfo.splice(i, 1);
                }
            }
        },
        commodityDetail(row) {
            this.tempRow=row;
            wmsApi
                .$axiosGetCommoditySku({ commodityId: row.id })
                .then((res) => {
                    this.detailVisable = true;
                    this.detailType = row.type;
                    if (this.detailType == 2) {
                        this.detailList = res.data.data;
                    } else {
                        this.detailList = res.data.data.childDetail;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>

<style scoped>
>>> .el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
.el-cascader--medium {
    width: 100%;
}
</style>
